import { GraduationCap, RefreshCw } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1660153083172-37cf41c10c99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnYXJkZW4lMjBpcnJpZ2F0aW9uJTIwcGxhbnRzfGVufDB8fHx8MTc3ODA4ODU0NHww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5">
          <p className="overline mb-6">— Chi sono</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A3628]">
            Una passione che <br />
            <span className="font-accent italic font-normal">affonda</span> le
            radici nella terra.
          </h2>
        </div>

        <div className="lg:col-span-7 lg:pt-10 grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="image-hover-wrap">
            <img
              src={ABOUT_IMG}
              alt="VERDEA · Alexander Ciarrocchi al lavoro"
              className="w-full h-[420px] md:h-[480px] object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex flex-col justify-center gap-6 text-[#2C3E50]">
            <p className="text-base md:text-lg leading-relaxed text-[#5C6B62]">
              Sono <strong className="text-[#1A3628] font-medium">Alexander Ciarrocchi</strong>,
              giardiniere per scelta e per amore della natura. Con il progetto
              <strong className="text-[#1A3628] font-medium"> VERDEA </strong>
              mi occupo di prendermi cura di giardini privati, terrazzi e spazi
              verdi a Milano e provincia, con un approccio attento all’equilibrio
              fra estetica, funzione e biodiversità.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-[#5C6B62]">
              Ogni progetto nasce dall’ascolto: del cliente, della pianta,
              del luogo. Lavoro con strumenti professionali e attenzione
              al dettaglio, perché un giardino curato è un piccolo gesto
              che dura nel tempo.
            </p>

            <div className="mt-2 pt-6 border-t border-[#D5D1C8] flex flex-col gap-5">
              <div className="flex items-start gap-4">
                <span className="inline-flex items-center justify-center w-11 h-11 border border-[#1A3628]/25 shrink-0">
                  <GraduationCap size={18} strokeWidth={1.5} className="text-[#1A3628]" />
                </span>
                <div>
                  <p className="overline">Formazione certificata</p>
                  <p className="text-base text-[#1A3628] mt-1 leading-snug">
                    Abilitazione professionale con esame finale presso la Scuola Agraria del Parco di Monza
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="inline-flex items-center justify-center w-11 h-11 border border-[#1A3628]/25 shrink-0">
                  <RefreshCw size={18} strokeWidth={1.5} className="text-[#1A3628]" />
                </span>
                <div>
                  <p className="overline">Aggiornamento continuo</p>
                  <p className="text-base text-[#1A3628] mt-1 leading-snug">
                    Corsi periodici su nuove tecniche, tecnologie e tendenze del verde
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
